<kendo-contextmenu #gridmenu [items]="grid().setup().actions" (select)="onActionItemClick($event)">
	<ng-template kendoMenuItemTemplate let-item="item">
		<div class='grid-action' [class.grid-action-not-enabled]='!isActionEnabled(item)'
			 [class.grid-menu-separated]='item.separated'>
			<i class="{{ item.iconClass }} fa-fw"></i>
			<span style='padding: 0 0.5em'>{{ item.label}}</span>
		</div>
	</ng-template>
</kendo-contextmenu>